import { get, } from '.';

export function GetAlertTypeSurveys(options = {}) {
	return get<any>("/app/api/alert_type_surveys", options);
}
